import type { Reducer } from 'redux';

import type { SessionLoadCurrentUserAction } from '../../../domains/sessionLoadCurrentUser/actions.types';

export type CurrentLocaleAction = SessionLoadCurrentUserAction;

const initialState = '';

const reducer: Reducer<string, CurrentLocaleAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.LOAD_CURRENT_USER_FULFILLED':
      return action.payload.locale;
    default:
      return state;
  }
};

export default reducer;
